var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite"},[(_vm.statefavorite)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'star']}}):_vm._e(),(!_vm.statefavorite)?_c('font-awesome-icon',{attrs:{"icon":['far', 'star']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }